Postlogin.CCISAssessment = (function (assessment) {
    assessment.Progress = {};
    const self = assessment.Progress;

    let isOpen = false;
    let progressNav = null;
    self.language = Postlogin.CCISAssessment.getLanguageSetting();

    self.init = function () {
        initEvents();

        // initialize item navigation
        progressNav = $('.assessment-navigation-wrapper .icon-list');
        $(progressNav).flickity({
            initialIndex: Postlogin.CCISAssessment.getCurrentItemIndex() - 1,
            cellAlign: 'center',
            pageDots: false,
            prevNextButtons: false,
        });

        $(progressNav).on('dragStart.flickity', function () {
            $(this).addClass('is-dragging');
        });

        $(progressNav).on('dragEnd.flickity', function () {
            $(this).removeClass('is-dragging');
        });

        $(progressNav).on('click', '.item-nav-blip', function (e) {
            e.preventDefault();
            const index = $(this).data('loop-index');

            $(progressNav).flickity('select', index);
            self.selectItem(index);
            $(progressNav).flickity('resize');

            Postlogin.CCISAssessment.goToItem(index);
            toggleMenu();
        });
    };

    /* Add all the item blips to the Progress Nav */
    self.populate = function (items) {
        $.each(items, (i, item) => {
            const $a = $('<a></a>');
            $a.attr('href', `#item-${i}`);
            $a.attr('id', `item-nav-blip-${i}`);
            $a.attr('data-item-id', item.assessment_item_id);
            $a.attr('data-loop-index', i);
            $a.attr('tabindex', '-1');
            $a.attr('title', item.name);
            $a.addClass('nav-blip');
            $a.addClass('item-nav-blip');
            $a.tooltipster({
                theme: 'tooltipster-vjs',
                animation: 'fade',
                delay: [50, 0],
            });

            if (typeof item.response !== 'undefined') {
                $a.addClass('started');
                $a.addClass('completed');
            }
            if (i === Postlogin.CCISAssessment.getFurthestItemIndex()) {
                $a.addClass('furthest');
            }
            if (i === Postlogin.CCISAssessment.getCurrentItemIndex()) {
                $a.addClass('current');
            }

            const $icon = $('<i></i>');
            $icon.addClass('fa');
            $icon.attr('aria-hidden', 'true');

            $icon.addClass('fa-question');

            $a.append($(`<span>${i + 1}</span>`));
            $(progressNav).flickity('append', $('<div></div>').append($a));
        });
    };

    const initEvents = function () {
        // Handle opening and closing of the My Progress menu
        $('#open-button').on('click', toggleMenu);

        if ($('#close-button').length) {
            $('#close-button').on('click', toggleMenu);
        }

        // close the menu element if the target it´s not the menu element or one of its descendants..
        $('body').on('click', '#content-container', (ev) => {
            const { target } = ev;
            if (isOpen && target !== $('#open-button')) {
                toggleMenu();
            }
        });
    };

    const toggleMenu = function () {
        if (isOpen) {
            $('body').removeClass('show-menu');
            $('#content-container, #clouds-background-container').removeClass('blur');
        } else {
            $(progressNav).flickity('resize');
            $(progressNav).flickity('reposition');
            $('body').addClass('show-menu');
            $('#content-container, #clouds-background-container').addClass('blur');
        }
        isOpen = !isOpen;
    };

    self.completeItem = function (itemIndex) {
        $(`#item-nav-blip-${itemIndex}`).addClass('completed');
    };

    self.selectItem = function (itemIndex) {
        if (!$(`#item-nav-blip-${itemIndex}`).hasClass('started')) {
            $('.item-nav-blip.furthest').removeClass('furthest');
            $(`#item-nav-blip-${itemIndex}`).addClass('furthest started');
        }
        $('.item-nav-blip.current').removeClass('current');
        $(`#item-nav-blip-${itemIndex}`).addClass('current');
        $(progressNav).flickity('select', itemIndex);
    };

    self.updatePercentComplete = function (percentage) {
        $('#assessment-percentage-complete').html(` — ${percentage}%`);
    };

    self.updatePageNumber = function (currentPage, totalPages) {
        self.language = Postlogin.CCISAssessment.getLanguageSetting();
        const { preposition } = Postlogin.CCISAssessment.languageData[self.language];
        $('#current-page').html(` — ${currentPage} <span class="preposition">${preposition}</span> ${totalPages}`);
    };

    return assessment;
}(Postlogin.CCISAssessment || {}));
